import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import CustomButton from '../customButton';
import ReorderItems from '../reorderItems';
import { reorder } from '../../../utility/helpers';
import LevelingFramework from './levelingFramework';

const useStyles = makeStyles(({ palette: { primary } }) => ({
  button: {
    borderRadius: 8,
    width: '100%',
    height: 40,
    minHeight: 40,
    backgroundColor: primary.bluish8,
    boxSizing: 'border-box',
    border: `1px solid ${primary.bluish6}`,
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: primary.bluish8,
    },
  },
}));

const LevelingFrameworks = ({
  translations,
  levelingFrameworks = [],
  isReadOnly = false,
  isExpandedOnFirstOpen = false,
  isExpandedOnFirstOpenFramework = false,
  canEdit = false,
  canDelete = false,
  onEditFrameworkTitle = () => {},
  onEditTrackTitle = () => {},
  onDuplicateFramework = () => {},
  onDuplicateTrack = () => {},
  handleDeleteFrameworkDialog = () => {},
  handleDeleteTrackDialog = () => {},
  handleCreateFramework = () => {},
  handleCreateLevel = () => {},
  handleCreateTrack = () => {},
  handleMoveTrack = () => {},
  onReorderLevel = () => {},
  onReorderTrack = () => {},
  onReorderFramework = () => {},
  handleEditSalaries = () => {},
  toggleExpansion = () => {},
  toggleExpansionFramework = () => {},
}) => {
  const classes = useStyles();

  const handleReorder = useCallback(
    result => {
      if (
        !result.destination ||
        result.source.index === result.destination.index
      )
        return;

      const updatedOrder = reorder(
        levelingFrameworks,
        result.source.index,
        result.destination.index
      );

      return onReorderFramework(updatedOrder);
    },
    [levelingFrameworks, onReorderFramework]
  );

  return (
    <div>
      <ReorderItems
        onSave={handleReorder}
        isDragDisabled={isReadOnly || !canEdit}
      >
        {levelingFrameworks?.map(levelingFramework => (
          <LevelingFramework
            key={`framework_group_${levelingFramework.id}`}
            id={levelingFramework.id}
            translations={translations}
            levelingFramework={levelingFramework}
            canEdit={canEdit}
            canDelete={canDelete}
            isExpandedOnFirstOpenFramework={isExpandedOnFirstOpenFramework}
            isReadOnly={isReadOnly}
            isExpandedOnFirstOpen={isExpandedOnFirstOpen}
            onEditFrameworkTitle={onEditFrameworkTitle}
            onEditTrackTitle={onEditTrackTitle}
            onDuplicateFramework={onDuplicateFramework}
            onDuplicateTrack={onDuplicateTrack}
            onReorderTrack={onReorderTrack}
            onReorderLevel={onReorderLevel}
            handleDeleteFrameworkDialog={handleDeleteFrameworkDialog}
            handleDeleteTrackDialog={handleDeleteTrackDialog}
            handleCreateLevel={handleCreateLevel}
            handleCreateTrack={handleCreateTrack}
            handleEditSalaries={handleEditSalaries}
            handleMoveTrack={handleMoveTrack}
            toggleExpansion={toggleExpansion}
            toggleExpansionFramework={toggleExpansionFramework}
          />
        ))}
      </ReorderItems>
      {!isReadOnly && canEdit && (
        <CustomButton
          className={classes.button}
          type="addWithTextDarkNewLarge"
          onClick={handleCreateFramework}
        >
          {translations.createFrameworkButton}
        </CustomButton>
      )}
    </div>
  );
};

LevelingFrameworks.propTypes = {
  translations: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
  levelingFrameworks: PropTypes.arrayOf(PropTypes.object),
  isExpandedOnFirstOpen: PropTypes.bool,
  isExpandedOnFirstOpenFramework: PropTypes.bool,
  canEdit: PropTypes.bool,
  canDelete: PropTypes.bool,
  handleEditSalaries: PropTypes.func,
  onEditFrameworkTitle: PropTypes.func,
  onEditTrackTitle: PropTypes.func,
  onDuplicateFramework: PropTypes.func,
  onDuplicateTrack: PropTypes.func,
  handleCreateFramework: PropTypes.func,
  handleCreateLevel: PropTypes.func,
  handleCreateTrack: PropTypes.func,
  handleMoveTrack: PropTypes.func,
  handleDeleteFrameworkDialog: PropTypes.func,
  handleDeleteTrackDialog: PropTypes.func,
  onReorderLevel: PropTypes.func,
  onReorderTrack: PropTypes.func,
  onReorderFramework: PropTypes.func,
  toggleExpansion: PropTypes.func,
  toggleExpansionFramework: PropTypes.func,
};

export default LevelingFrameworks;
